import { render, staticRenderFns } from "./CreateInspectorTeam.vue?vue&type=template&id=4b1463f7&"
import script from "./CreateInspectorTeam.vue?vue&type=script&lang=js&"
export * from "./CreateInspectorTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports